import React from 'react';
import "./Rewards.css";
import { FaLongArrowAltRight } from 'react-icons/fa';

export const Join = () => {
    return <div className='row m-0 mt-5 d-flex justify-content-center'>
        <div className='join-bg col-md-9 col-10 d-flex justify-content-center justify-content-md-between align-items-center flex-wrap flex-md-nowrap p-3 p-md-5'>
            <div>
                <h1 className='text-white text-center text-md-start'>Start earning today!</h1>
                <p className=' yellow text-center text-md-start'>Unlimited Referrals. Unlimited Rewards</p>
            </div>
            <button>
                <small>Join & Refer Friends</small> 
                <FaLongArrowAltRight/>
            </button>
        </div>

    </div>
}